var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSave = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 18V3C1 1.89543 1.89543 1 3 1H12.6158C13.2737 1 13.8896 1.32358 14.2628 1.86539L19.647 9.68115C19.8769 10.0149 20 10.4105 20 10.8158V18C20 19.1046 19.1046 20 18 20H3C1.89543 20 1 19.1046 1 18Z",
  stroke: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 7.5C12.2761 7.5 12.5 7.27614 12.5 7C12.5 6.72386 12.2761 6.5 12 6.5V7.5ZM7.5 1V5H8.5V1H7.5ZM10 7.5H12V6.5H10V7.5ZM7.5 5C7.5 6.38071 8.61929 7.5 10 7.5V6.5C9.17157 6.5 8.5 5.82843 8.5 5H7.5Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 20V16C6 14.8954 6.89543 14 8 14H13C14.1046 14 15 14.8954 15 16V20",
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSave);
export { ForwardRef as ReactComponent };